import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';
import Seo from '../../components/Seo/Seo';

const NotFound = () => {
  return (
    <section className="not-found-page py-20 px-4">
      <Seo title="Page Not Found" description="The page you are looking for could not be found." noIndex />
      <div className="max-w-3xl mx-auto text-center">
        <p className="not-found-code">404</p>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Page Not Found</h1>
        <p className="text-gray-600 text-base md:text-lg mb-8">
          The page you are looking for might have been removed, renamed, or is temporarily unavailable.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/" className="not-found-btn primary">
            Go To Homepage
          </Link>
          <Link to="/services" className="not-found-btn secondary">
            Browse Services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
